/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/719060/%E9%A6%9611%E6%9C%88%E9%9B%BB%E9%83%B5%E9%A8%99%E6%A1%88%E5%A4%B114%E5%84%84%E5%85%83-%E9%A8%99%E5%BE%92%E9%9B%BB%E9%83%B5%E5%9C%B0%E5%9D%80-s%E8%BD%89z-%E6%89%AE%E7%94%9F%E6%84%8F%E5%A4%A5%E4%BC%B4%E5%91%83%E5%8D%83%E8%90%AC'
          );
        }}
        className="source1"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/719060/%E9%A6%9611%E6%9C%88%E9%9B%BB%E9%83%B5%E9%A8%99%E6%A1%88%E5%A4%B114%E5%84%84%E5%85%83-%E9%A8%99%E5%BE%92%E9%9B%BB%E9%83%B5%E5%9C%B0%E5%9D%80-s%E8%BD%89z-%E6%89%AE%E7%94%9F%E6%84%8F%E5%A4%A5%E4%BC%B4%E5%91%83%E5%8D%83%E8%90%AC'
          );
        }}
        className="source1"
      />
    </div>
  </>
);

export default Components004;
